module.exports = __webpack_public_path__ + "img/11-singha-thai.508e359f.jpg";